import { DateTime, Interval } from 'luxon'
import React, { useEffect, useState } from 'react'
import { Icon, Select, FlexRow, FlexColumn, DatePicker } from 'elements'
import calculateDatePeriods from 'shared/datasets/date-periods'

const datePeriods = calculateDatePeriods()
const customOption = { label: 'Custom', value: 'custom' }
const options = [customOption, ...datePeriods]

function findPeriod(start, end) {
  if (!start || !end || start > end) {
    return customOption
  }

  const startDate = DateTime.fromJSDate(start)
  const endDate = DateTime.fromJSDate(end)

  const period = datePeriods.find((period) => {
    const { interval } = period

    return interval.start?.hasSame(startDate, 'day') && interval.end?.hasSame(endDate, 'day')
  })

  if (period) {
    return period
  }

  // return custom w/ these dates
  return {
    ...customOption,
    interval: Interval.fromDateTimes(startDate, endDate),
  }
}

export default function DatePeriodInput({ value, disabled, onChange, styleProps, customInput }) {
  const [datePeriodStart, setReportPeriodStart] = useState(null)
  const [datePeriodEnd, setReportPeriodEnd] = useState(null)

  useEffect(() => {
    if (value && value.interval) {
      const { interval } = value
      setReportPeriodStart(interval.start.toJSDate())
      setReportPeriodEnd(interval.end.toJSDate())
    }
  }, [value])

  const handleIntervalChange = (option) => {
    if (option.value === 'custom') {
      setReportPeriodStart(null)
      setReportPeriodEnd(null)
      onChange(customOption)
    } else {
      onChange(option)
    }
  }

  const handleStartChange = (value) => {
    setReportPeriodStart(value)
    onChange(findPeriod(value, datePeriodEnd))
  }

  const handleEndChange = (value) => {
    setReportPeriodEnd(value)
    onChange(findPeriod(datePeriodStart, value))
  }

  return (
    <FlexColumn>
      <FlexColumn mb="medium">
        <Select
          disabled={disabled}
          options={options}
          value={value}
          getOptionLabel={(option) => option.label}
          getOptionValue={(option) => option.value}
          isOptionDisabled={(option) => option.disabled}
          onChange={handleIntervalChange}
        />
      </FlexColumn>
      <FlexRow>
        <FlexColumn flex="1" mr="small">
          <DatePicker
            styleProps={styleProps?.datePicker}
            disabled={disabled}
            value={datePeriodStart}
            onChange={handleStartChange}
            placeholder="MM/DD/YYYY"
            customInput={customInput}
          />
        </FlexColumn>
        <FlexColumn mr="small" justifyContent="center">
          <Icon name="minus" color="neutral.0">
            –
          </Icon>
        </FlexColumn>
        <FlexColumn flex="1">
          <DatePicker
            styleProps={styleProps?.datePicker}
            disabled={disabled}
            value={datePeriodEnd}
            onChange={handleEndChange}
            placeholder="MM/DD/YYYY"
            customInput={customInput}
          />
        </FlexColumn>
      </FlexRow>
    </FlexColumn>
  )
}
